import React from 'react';
import DevicesOverviewGrid from '../DevicesOverviewGrid/DevicesOverviewGrid';
import { DevicesOverviewProps } from '../DeviceOverview.util';

function DevicesOverviewGridSmall(props: DevicesOverviewProps) {
  return <DevicesOverviewGrid {...props} showImage={false} />;
}

export default DevicesOverviewGridSmall;
